module.exports = __webpack_public_path__ + "img/template7.b1618a16.png";